import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { RadioButton } from "primereact/radiobutton";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import classNames from "classnames";
import { useSelector, useDispatch } from "react-redux";
import { GetParserHeadDetailsAction, GetParserHeadFurtherDetailsAction, SetEditParserHeadDetailsFlagAction } from "../../../redux/actions/companyAction";
import { handlePostRequest } from "../../../services/PostTemplate";
import { Checkbox } from "primereact/checkbox";
import { Dropdown } from "primereact/dropdown";
import * as Yup from "yup";
import { handlePutRequest } from "../../../services/PutTemplate";

function AddEditParserHeadDetails({ parserHeadId, handleParserHeadId, parserDetailId }) {
    const [loading, setloading] = useState(true);
    const [loadingIcon, setloadingIcon] = useState("pi pi-save");
    const dispatch = useDispatch();

    const parserDetailId__Store = useSelector((state) => state.companySlice?.parserDetailId);

    const parseHeadFurtherDetails = useSelector((state) => state.companySlice?.parserHeadFurtherDetails);
    const formData__Store = useSelector((state) => state.companySlice?.parserHeadDetailsFormData);
    const editFlag__Store = useSelector((state) => state.companySlice?.parserHeadDetailsEditFlag);

    useEffect(() => {
        if ((parserDetailId !== undefined && parserDetailId !== null && parserDetailId !== "") || (parserDetailId__Store !== "" && parserDetailId__Store !== undefined && parserDetailId__Store !== null)) {
            setloading(false);
        } else {
            setloading(true);
        }
    }, [parserDetailId, parserDetailId__Store]);

    const columnTypeOptions = [{ label: "String", value: "String" }];

    useEffect(() => {
        if (editFlag__Store) {
            fillParserHeadDetailForm();
        }
    }, [editFlag__Store, formData__Store]);

    const fillParserHeadDetailForm = () => {
        formik.setFieldValue("columnName", formData__Store?.columnName?.toString());
        const columnType = { code: formData__Store?.tblProduct?.masterProductCode, maxLength: formData__Store?.tblProduct?.masterProductName, id: formData__Store?.tblProduct?.columnType?.toString(), longText: null, shortText: null };
        formik.setFieldValue("fixedLength", formData__Store?.fixedLength?.toString() === "Y" ? true : false);
        formik.setFieldValue("maxLength", formData__Store?.maxLength?.toString());
        formik.setFieldValue("minLength", formData__Store?.minLength?.toString());
        formik.setFieldValue("isMandatory", formData__Store?.isMandatory);
        formik.setFieldValue("isSearchable", formData__Store?.isSearchable?.toString() === "Y" ? true : false);
        formik.setFieldValue("columnType", columnType);
    };

    const validationSchema = Yup.object().shape({
        columnName: Yup.string().required("This field is required."),
        columnType: Yup.mixed().required("This field is required."),
        minLength: Yup.string().required("This field is required.").matches("^[0-9]*$", "Please enter numeric data").max(3, "Max length 3 allowed"),
        maxLength: Yup.string().required("This field is required.").matches("^[0-9]*$", "Please enter numeric data").max(3, "Max length 3 allowed"),
    });

    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            columnName: "",
            columnType: "",
            isMandatory: "N",
            fixedLength: false,
            maxLength: "",
            minLength: "",
            isSearchable: false,
        },
        validate: (data) => {
            let errors = {};

            if (data.minLength) {
                if (parseInt(data.minLength) > parseInt(data.maxLength)) {
                    errors.minLength = "Minimum length should be less than to Maximum length";
                }
            }

            return errors;
        },
        onSubmit: async (data) => {
            data["isSearchable"] = data.isSearchable ? "Y" : "N";
            data["fixedLength"] = data.fixedLength ? "Y" : "N";
            data["sequence"] = parseHeadFurtherDetails?.length + 1;
            setloading(true);
            setloadingIcon("pi pi-spin pi-spinner");

            if (editFlag__Store) {
                if (parserHeadId !== "") data["parserDetailId"] = parserDetailId__Store;
                else data["parserDetailId"] = parserDetailId__Store;
                await handlePutRequest(data, "/zbizgateway/nonFin/updateParserDetails");
                await dispatch(GetParserHeadDetailsAction("zbizgateway/nonFin/getAllParsers"));
                handleParserHeadId();
                dispatch(GetParserHeadFurtherDetailsAction("zbizgateway/nonFin/getParser/" + data["parserHeadId"]));
                dispatch(SetEditParserHeadDetailsFlagAction(false));
            } else {
                if (parserHeadId !== "") data["parserHeadId"] = parserHeadId;
                else data["parserHeadId"] = parserDetailId__Store;
                await handlePostRequest(data, "zbizgateway/nonFin/saveParserDetails");
                handleParserHeadId();
                dispatch(GetParserHeadDetailsAction("zbizgateway/nonFin/getAllParsers"));
                dispatch(GetParserHeadFurtherDetailsAction("zbizgateway/nonFin/getParser/" + data["parserHeadId"]));
            }

            setloading(false);
            setloadingIcon("pi pi-save");
            formik.resetForm();
        },
    });
    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    const handleCancel = (e) => {
        e.preventDefault();
        formik.resetForm();
        dispatch(SetEditParserHeadDetailsFlagAction(false));
        // dispatch(SetParserHeadDetailsToNullAction());
    };

    return (
        <div className="card Card__Round">
            <div className="Form__Header">
                <h1>Parser Head Details</h1>
            </div>
            <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
                <div className="p-fluid p-formgrid p-grid">
                    <div className="p-field p-col-12 p-md-3">
                        <div className="p-field">
                            <label htmlFor="columnName" className={classNames({ "p-error": isFormFieldValid("columnName") }, "Label__Text")}>
                                Column Name<span className="Label__Required">*</span>
                            </label>
                            <InputText id="columnName" placeholder="Enter Column Name" name="columnName" value={formik.values.columnName} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("columnName") }, "Input__Round")} />

                            {getFormErrorMessage("columnName")}
                        </div>
                    </div>
                    <div className="p-field p-col-12 p-md-3">
                        <div className="p-field">
                            <label htmlFor="columnType" className={classNames({ "p-error": isFormFieldValid("columnType") }, "Label__Text")}>
                                Column Type<span className="Label__Required">*</span>
                            </label>
                            <Dropdown
                                options={columnTypeOptions}
                                optionLabel="label"
                                id="columnType"
                                placeholder="Enter Column Type"
                                name="columnType"
                                value={formik.values.columnType}
                                onChange={formik.handleChange}
                                className={classNames({ "p-invalid": isFormFieldValid("columnType") }, "Dropdown__Round")}
                            />

                            {getFormErrorMessage("columnType")}
                        </div>
                    </div>
                    <div className="p-field p-col-12 p-md-3">
                        <div className="p-field">
                            <label htmlFor="fixedLength" className={classNames({ "p-error": isFormFieldValid("fixedLength") }, "Label__Text")}>
                                Fixed Length
                            </label>
                            <div className="field-checkbox">
                                <Checkbox inputId="fixedLength" name="fixedLength" value={formik.values.fixedLength} checked={formik.values.fixedLength} onChange={formik.handleChange} />
                            </div>
                            {getFormErrorMessage("fixedLength")}
                        </div>
                    </div>
                    <div className="p-field p-col-12 p-md-3">
                        <div className="p-field">
                            <label htmlFor="minLength" className={classNames({ "p-error": isFormFieldValid("minLength") }, "Label__Text")}>
                                Min Length<span className="Label__Required">*</span>
                            </label>
                            <InputText id="minLength" placeholder="Enter Length" name="minLength" value={formik.values.minLength} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("minLength") }, "Input__Round")} />

                            {getFormErrorMessage("minLength")}
                        </div>
                    </div>
                    <div className="p-field p-col-12 p-md-3">
                        <div className="p-field">
                            <label htmlFor="maxLength" className={classNames({ "p-error": isFormFieldValid("maxLength") }, "Label__Text")}>
                                Max Length<span className="Label__Required">*</span>
                            </label>
                            <InputText id="maxLength" placeholder="Enter Length" name="maxLength" value={formik.values.maxLength} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("maxLength") }, "Input__Round")} />

                            {getFormErrorMessage("maxLength")}
                        </div>
                    </div>

                    <div className="p-field p-col-12 p-md-3">
                        <label htmlFor="isMandatory" className="Label__Text">
                            Mandatory
                        </label>
                        <div className="Radio__Btn">
                            <div className="p-field-radiobutton">
                                <RadioButton inputId="isMandatory" name="isMandatory" value={"N"} onChange={formik.handleChange} checked={formik.values.isMandatory === "N"} />
                                <label htmlFor="isMandatory">No</label>
                            </div>
                            <div className="p-field-radiobutton">
                                <RadioButton inputId="isMandatory" name="isMandatory" value={"Y"} onChange={formik.handleChange} checked={formik.values.isMandatory === "Y"} />
                                <label htmlFor="isMandatory">Yes</label>
                            </div>
                        </div>
                    </div>
                    <div className="p-field p-col-12 p-md-3">
                        <label htmlFor="isSearchable" className="Label__Text">
                            Is Searchable
                        </label>
                        <div className="Checkbox__Btn">
                            <div className="field-checkbox">
                                <Checkbox inputId="isSearchable" name="isSearchable" value={formik.values.isSearchable} checked={formik.values.isSearchable} onChange={formik.handleChange} />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="Down__Btn">
                    <Button label="Cancel" onClick={(e) => handleCancel(e)} className="Btn__Transparent" />
                    <Button type="submit" disabled={parserHeadId === undefined || parserHeadId === null || parserDetailId__Store !== undefined ? false : loading} icon={loadingIcon || ""} iconPos="right" label={editFlag__Store ? "Edit" : "Add"} className="Btn__Dark" />
                </div>
            </form>
        </div>
    );
}

export default AddEditParserHeadDetails;
